// Transparent logos for both themes so no white box shows on any surface.
import mainLogo from '@/assets/new_updated_logo_light_without_bg.png'
import mainLogoDark from '@/assets/New update logo without bg.png'
import yandleMark from '@/assets/yandle-mark.svg'

/**
 * Resolves the Yandle brand logo for the login page.
 * Org white-label logos take priority when provided.
 *
 * @param {{ isDark?: boolean, orgLogoUrl?: string|null, variant?: 'full'|'mark' }} options
 * @returns {string}
 */
export function resolveLoginBrandLogo({
  isDark = true,
  orgLogoUrl = null,
  variant = 'full',
} = {}) {
  const orgLogo = String(orgLogoUrl ?? '').trim()
  if (orgLogo) return orgLogo

  if (variant === 'mark') return yandleMark

  return isDark ? mainLogoDark : mainLogo
}

export const loginBrandAssets = {
  mainLogo,
  mainLogoDark,
  yandleMark,
}
